import React from 'react';
import IntegrationBlock from '../../index';
import StatusBlock from '../StatusBlock';
import TechData from '../TechData';

const SupplyData = (props) => {
  const { data, modalType } = props;

  return (
    <>
      {data !== undefined && data !== null && (
        <>
          <IntegrationBlock
            title="Подтверждение поставки"
            isChangable={false}
            modalType={modalType}
            modalData={data}
            isSaveable={false}
          >
            <p>Номер поставки: {data.supplyData?.supplyNumber}</p>
          </IntegrationBlock>
          <StatusBlock
            status={data.techData?.supplyTechData?.supplyStatus}
            syncro={data.techData?.supplyTechData?.supplySynchronized}
            draftErrors={data.techData?.supplyTechData?.supplyErrors}
          />
          <TechData
            code={data.techData?.supplyTechData?.supplyCreateOperationId}
            date={data.techData?.supplyTechData?.supplyRequestTs}
            ozonDate={data.techData?.supplyTechData?.supplySyncResultTs}
          />
        </>
      )}
    </>
  );
};

export default SupplyData;
